module.exports = __webpack_public_path__ + "static/media/B2.c228e6d2.jpg";